export const DISCUSSION_STATUS = {
    OPEN: 'open',
    CLOSED: 'closed',
};
export const DISCUSSION_SORT_FIELD = {
    NEWEST: 'newest',
    UNREAD: 'unread',
    REPLIES: 'replies',
    TITLE: 'title',
};
export const DISCUSSION_SORT_OPTIONS = [
    { value: DISCUSSION_SORT_FIELD.NEWEST, label: 'Newest', icon: 'bi-calendar-plus' },
    { value: DISCUSSION_SORT_FIELD.UNREAD, label: 'Unread first', icon: 'bi-envelope' },
    { value: DISCUSSION_SORT_FIELD.REPLIES, label: 'Most replies', icon: 'bi-chat-dots' },
    { value: DISCUSSION_SORT_FIELD.TITLE, label: 'Title A-Z', icon: 'bi-sort-alpha-down' },
];
export const createDiscussionState = () => ({
    id: null,
    title: '',
    description: '',
    kind: null,
    category_id: null,
});
